import type { EnergyRevenuesListResponse } from "../../../RevenueMonitoring.types";

export function calculateTotalVolume(
  energyRevenuesData: EnergyRevenuesListResponse
) {
  if (energyRevenuesData.every((value) => value.vermarktung_volume === null)) {
    return null;
  }
  return energyRevenuesData.reduce((acc, curr) => {
    return acc + (curr.vermarktung_volume ?? 0);
  }, 0);
}
